import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import OverviewProgressCard from 'View/host/component/overview-progress-card';
import OverviewNumbers from 'View/host-achievement-detail/component/overview-numbers';

import styles from './styles.module.css';

const TargetProgress = ({ userProgress, isFetching }) => {
  const { t } = useTranslation('host-achievement');

  return (
    <Box className={styles['target-progress__container']}>
      <Box className={styles['top-progress__container']}>
        <OverviewProgressCard
          isLoading={isFetching}
          title={t('page.brand_revenue')}
          targetCount={userProgress?.brandRevenue.target}
          progressCount={userProgress?.brandRevenue.progress}
          progressPercentage={userProgress?.brandRevenue.progressPercentage}
          isCurrency={true}
          size="lg"
        />
        <OverviewProgressCard
          isLoading={isFetching}
          title={t('page.brand_views')}
          targetCount={userProgress?.viewsBrand.target}
          progressCount={userProgress?.viewsBrand.progress}
          progressPercentage={userProgress?.viewsBrand.progressPercentage}
          size="lg"
        />
      </Box>

      <Box className={styles['center-progress__container']}>
        <Flex gap="16px" maxWidth={'100%'}>
          <OverviewProgressCard
            isLoading={isFetching}
            title={t('page.brand_aov')}
            targetCount={userProgress?.aov.target}
            progressCount={userProgress?.aov.progress}
            progressPercentage={userProgress?.aov.progressPercentage}
            isCurrency={true}
          />
          <OverviewProgressCard
            isLoading={isFetching}
            title={t('page.brand_ctor')}
            targetCount={userProgress?.ctor.target}
            progressCount={userProgress?.ctor.progress}
            progressPercentage={userProgress?.ctor.progressPercentage}
            uom={userProgress?.ctor.uom}
            uomPosition={userProgress?.ctor.uomPosition}
          />
        </Flex>
        <Flex gap="16px">
          <OverviewProgressCard
            isLoading={isFetching}
            title={t('page.brand_ctr')}
            targetCount={userProgress?.ctr.target}
            progressCount={userProgress?.ctr.progress}
            progressPercentage={userProgress?.ctr.progressPercentage}
            uom={userProgress?.ctr.uom}
            uomPosition={userProgress?.ctr.uomPosition}
          />
          <OverviewProgressCard
            isLoading={isFetching}
            title={t('page.brand_err')}
            targetCount={userProgress?.err.target}
            progressCount={userProgress?.err.progress}
            progressPercentage={userProgress?.err.progressPercentage}
            uom={userProgress?.err.uom}
            uomPosition={userProgress?.err.uomPosition}
          />
        </Flex>
      </Box>
      <Box className={styles['bottom-progress__container']}>
        <OverviewNumbers title={t('page.live_duration')} count={userProgress?.totalLiveDuration} uom="jam" uomPosition="right" isLoading={isFetching} />
        <OverviewNumbers title={t('page.total_live_sessions')} count={userProgress?.totalLiveSession} isLoading={isFetching} />
      </Box>
    </Box>
  );
};

export default TargetProgress;
